import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Autocomplete from "@mui/material/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Popper, { PopperProps } from "@mui/material/Popper";
import TextField from "@mui/material/TextField";
import React, { useEffect, useRef, useState } from "react";
import { menuSelect } from "../ComponentInterface";
import { Prefixes } from "../MainPage/Tools/ProjectX";
import smetaAxios from "../SmetaAxios";
import { getLastLogin } from "../Url";

// eslint-disable-next-line @typescript-eslint/naming-convention
const SelectWorkPlace = (props: menuSelect) => {
  const lastWorkPlace = getLastLogin().split(",");
  const [workplaces, setWorkPlaces] = useState<Record<string, string>>({});
  const [value, setValue] = useState(lastWorkPlace === undefined ? "" : lastWorkPlace[2]);
  const [inputValue, setInputValue] = useState("");
  const [loading, setLoad] = useState(true);
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement | null>(null);
  useOutsideAlerter(wrapperRef);

  function useOutsideAlerter(ref: React.MutableRefObject<HTMLDivElement | null>) {
    useEffect(() => {
      function handleClickOutside(event: MouseEvent) {
        const target = event.target as HTMLElement;
        if (ref.current && !ref.current.contains(target)) {
          if (target.id === "iconWP" || target.id === "buttonWP" || target.id === "WP") {
          } else {
            setOpen(false);
          }
        }
      }

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  const popperMy = (props: PopperProps) => {
    return <Popper {...props} placement="bottom-start" onClick={changeOpen} ref={wrapperRef} />;
  };

  const changeOpen = () => {
    setOpen(!open);
  };

  const getWorkPlaces = async () => {
    setOpen(!open);
    setLoad(true);
    if (!open && props.userInfo !== "" && props.drxInfo !== "") {
      setWorkPlaces(
        await smetaAxios.get("getworkplacelist", {
          prefix: Prefixes.default,
          params: { ConfigName: encodeURIComponent(props.drxInfo), UserName: encodeURIComponent(props.userInfo) },
          loadMask: true,
        }),
      );
    }
    setLoad(false);
  };

  const onKeyEnter = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === "Enter" && open === false) {
      props.KeyDown(e);
    } else if (e.key === "ArrowDown" && open === false) {
      getWorkPlaces();
    }
  };

  function menuItems(userList: Record<string, string>) {
    const array = [];
    for (const value of Object.values(userList)) {
      array.push(`${value}`);
    }
    return array;
  }

  return (
    <Grid item xs>
      <Autocomplete
        open={open}
        PopperComponent={popperMy}
        loading={loading}
        loadingText={
          props.userInfo === "" || props.drxInfo === "" ? "Необходимо выбрать пользователя" : <CircularProgress />
        }
        freeSolo
        fullWidth
        disableClearable
        value={value}
        onChange={(event, newValue) => {
          setValue(newValue);
        }}
        inputValue={inputValue}
        onInputChange={(event, newInputValue) => {
          props.setBackInfo(newInputValue);
          setInputValue(newInputValue);
        }}
        id="WP"
        options={menuItems(workplaces)}
        onKeyDown={onKeyEnter}
        renderInput={(params) => (
          <TextField
            autoComplete="off"
            {...params}
            label="Рабочее место"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={getWorkPlaces} id={"buttonWP"}>
                    <ArrowDropDownIcon id={"iconWP"} />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        )}
      />
    </Grid>
  );
};

export default SelectWorkPlace;
